export default "__VITE_ASSET__vNpCGCEf__"